import LocomotiveScroll from 'locomotive-scroll'
import imagesLoaded from 'imagesloaded'
import gsap, { Linear, Power0, Expo } from 'gsap'
import Carousel from "./classes/Carousel"
import Swiper, { Pagination, Navigation } from 'swiper'
import barba from '@barba/core'
import ParallaxSlider from './classes/ParallaxSlider'
import { bind as niceSelectBind } from 'nice-select2/src/js/nice-select2'
import tippy from 'tippy.js'
import VideoButton from './library/VideoButton'
import Booking from './library/Booking';
import Preloader from './library/Preloader';
import MasonryGallery from './library/MasonryGallery'
import Lazy from './library/Lazy'
import lightGallery from 'lightgallery'
import lgZoom from 'lightgallery/plugins/zoom'
import Plyr from 'plyr'
import PinchZoom from 'pinch-zoom-js'
import Pristine from 'pristinejs'
import pristine from 'pristinejs'
import Cookie from 'js-cookie'
import dayjs from 'dayjs'

export function triggerResize() {
    let ev = document.createEvent('HTMLEvents');
    ev.initEvent('resize', true, false);
    window.dispatchEvent(ev);
}

function removeCookiePopup(updateCookie = false) {
    if (updateCookie) {
        Cookie.set('cookie-consent-closed', true, {
            expires: dayjs().add(1, 'month').toDate()
        })
    }

    document.querySelector('.cookie-consent').remove();
}

window.addEventListener('load', function () {
    const button = document.querySelector('.cookie-consent__item .btn')
    const close = document.querySelector('.cookie-consent .close')

    const acceptCookie = function () {
        removeCookiePopup(true);
    }

    button.addEventListener('click', acceptCookie)
    close.addEventListener('click', acceptCookie)

    if (Cookie.get('cookie-consent-closed') != null) {
        removeCookiePopup();
    }
});

window.onSubscribe = (response) => {
    const newsletterForm = document.querySelector('#newsletter-form');
    const valid = window.newsletterPristine.validate()

    if (valid) {
        newsletterForm.submit();
    } else {
        grecaptcha.reset();
    }
}

window.onMobileSubscribe = (response) => {
    const newsletterForm = document.querySelector('#newsletter-mobile-form');
    const valid = window.newsletterPristine.validate()

    if (valid) {
        newsletterForm.submit();
    } else {
        grecaptcha.reset();
    }
}

window.openNavigation = () => {
    const container = document.querySelector('.navbar-dropdown__wrapper')

    gsap.set(container, { display: 'block' })

    gsap.fromTo(container, {
        duration: .2,
        clipPath: 'inset(0 0 0 100%)',
        webkitClipPath: 'inset(0 0 0 100%)',
    }, {
        clipPath: 'inset(0 0 0 0%)',
        webkitClipPath: 'inset(0 0 0 0%)',
        ease: Expo.easeOut,
    })

    gsap.fromTo(['.navbar-dropdown__item', '.navbar-dropdown__social-title', '.navbar-dropdown__social-container'], {
        duration: .2,
        y: '100%',
        opacity: 0,
    }, {
        y: 0,
        opacity: 1,
        stagger: .1,
    })

    gsap.fromTo('.navbar-dropdown__social-close', {
        duration: .2,
        opacity: 0
    }, {
        opacity: 1,
    })
}

window.closeNavigation = () => {
    const container = document.querySelector('.navbar-dropdown__wrapper')

    gsap.to(container, {
        duration: .2,
        clipPath: 'inset(0 0 0 100%)',
        webkitClipPath: 'inset(0 0 0 100%)',
        ease: Expo.easeOut,
        onComplete: () => {
            gsap.set(container, { display: 'none' })
        }
    })

    const body = document.querySelector('.menu-open')

    if (body != null) {
        body.classList.remove('menu-open')
    }
}

const updateHeader = (data) => {
    const shortlink = document.querySelector('link[rel=shortlink]')
    shortlink.setAttribute('href', window.location.href)

    const canonical = document.querySelector('link[rel=canonical]')
    canonical.setAttribute('href', window.location.href)
}

const init = () => {
    const select = document.querySelector('#country')

    const gallery = document.querySelector('.wp-block-migb-masonry-gallery')

	const country = document.querySelector('#country')
        if (country != null) {
country.setAttribute('data-label', 'Select an option');
        }

	    const recappedEls = document.querySelectorAll('.wpcf7-recaptcha');
    for (let el of recappedEls) {
        if (grecaptcha != null && !el.hasChildNodes()) {
            grecaptcha.render(el)
        }
    }

    if (gallery != null) {
        const lg = lightGallery(gallery)

        gallery.addEventListener('lgAfterOpen', () => {
            const img = document.querySelector('.lg-content-1')
            new PinchZoom(img)
        });
    }

    const spacers = document.querySelectorAll('.section .wp-block-spacer')

    for (let spacer of spacers) {
        spacer.parentElement.style.zIndex = -1
    }

    const vidEl = document.querySelector('.hero video')
    const imgEl = document.querySelector('.hero .background-image')

    if (vidEl != null) {
        gsap.set(vidEl, { opacity: 0 })
        vidEl.addEventListener('loadeddata', () => {
            gsap.to(vidEl, {
                opacity: 1,
                duration: .5,
            })
        })
    }

    new VideoButton();
    new MasonryGallery();
    new Lazy()

    if (select != null) {
        niceSelectBind(select)

        const dropdown = document.querySelector('.nice-select-dropdown')
        dropdown.addEventListener('mouseover', () => {
            window.flvScroll.stop()
        })

        dropdown.addEventListener('mouseout', () => {
            window.flvScroll.start()
        })


        setTimeout(() => {
            const niceSelectDefault = document.querySelector('.nice-select .current')
            const label = select.dataset.label
            if (niceSelectDefault) {
                niceSelectDefault.innerHTML = label
            }
        }, 100)

    }

    const carouselEl = document.querySelector('.carousel__planes')

    if (carouselEl != null) {
        const options = {
            duration: 500,
            dragSpeed: 1.5,
            element: carouselEl,
        }

        window.carousel = new Carousel(options)

        const parent = carouselEl.parentElement.parentElement.parentElement
        const prevEl = parent.querySelector('.carousel__navigation-prev')
        const nextEl = parent.querySelector('.carousel__navigation-next')

        prevEl.addEventListener('click', function () {
            window.carousel.previous();
        })

        nextEl.addEventListener('click', function () {
            window.carousel.next();
        })
    }

    const zigzag = new Swiper('.zigzag-carousel__container', {
        modules: [Navigation],
        slidesPerView: 'auto',
        centeredSlides: false,
        navigation: {
            prevEl: '.zigzag-carousel__container .slider-desc__navigation-prev',
            nextEl: '.zigzag-carousel__container .slider-desc__navigation-next',
        },
    })

    zigzag.on('slideChange', () => {
        let percentage = 0;

        if (window.innerWidth < 428.98) {
            percentage = (zigzag.activeIndex) / (zigzag.slides.length - 1) * 100;
        } else {
            percentage = (zigzag.activeIndex) / ((zigzag.slides.length - 1) - ((zigzag.slides.length - 1) % 3)) * 100;
        }

        const progress = zigzag.$el[0].querySelector('.slider-desc__percentage')
        gsap.to(progress, {
            width: percentage + '%',
        })
    })


    const imageButtonEl = document.querySelector('.image-button__container');

    const wawa = new Swiper(imageButtonEl, {
        modules: [Pagination],
        slidesPerView: 1,
        pagination: {
            el: '.image-button__navigation',
        },
        breakpoints: {
            428.98: {
                slidesPerView: 4,
            }
        }
    })

    window.wawa = wawa
    window.zigzag = zigzag

    const sliderDesc = new Swiper('.slider-desc__swiper .swiper', {
        modules: [Navigation],
        slidesPerView: 'auto',
        centeredSlides: true,
        navigation: {
            prevEl: '.slider-desc__navigation-prev',
            nextEl: '.slider-desc__navigation-next',
        }
    })

    sliderDesc.on('slideChange', () => {
        const percentage = (sliderDesc.activeIndex) / (sliderDesc.slides.length - 1) * 100;

        const progress = sliderDesc.$el[0].nextElementSibling.firstElementChild
        gsap.to(progress, {
            width: percentage + '%',
        })
    })

    window.sliderDesc = sliderDesc

    const heroText = document.querySelector('.hero-text__container')
    const navbar = document.querySelector('.navbar')

    if (heroText != null) {
        navbar.classList.add('dark')
    } else {
        navbar.classList.remove('dark')
    }

    setTimeout(() => {
        navbar.classList.remove('scroll')
    }, 1000)

    const links = document.querySelectorAll('.privacy-policy__menu a')

    for (let link of links) {
        link.addEventListener('click', function () {
            let id = link.href.split('#')

            if (id.length > 1) {
                id = id[1]

                window.flvScroll.scrollTo(document.querySelector('#' + id), {
                    offset: -100,
                })
            }
        })
    }

    // sign up
    const signupBtn = document.querySelector('.inspiration .btn');

    if (signupBtn != null) {
        signupBtn.addEventListener('click', function () {
            let id = signupBtn.href.split('#')

            if (id.length > 1) {
                id = id[1]

                if (window.innerWidth < 428.98) {
                    window.flvScroll.scrollTo(document.querySelector('.footer.mobile #' + id), {
                        offset: -100,
                    })
                } else {
                    window.flvScroll.scrollTo(document.querySelector('#' + id), {
                        offset: -100,
                    })
                }


                document.querySelector('#newsletter-email').focus()
            }
        })

    }

    const hasAccents = document.querySelectorAll('.has-accent')

    for (let hasAccent of hasAccents) {
        hasAccent.parentElement.style.zIndex = 0;
    }

    const tables = document.querySelectorAll('.is-style-bottom-border')

    let i = 0;
    for (let table of tables) {
        const title = table.querySelector('figcaption')

        if (tables.length - 1 === i) {
            table.parentElement.classList.add('table-last');
        }

        const tb = table.querySelector('table')
        table.classList.add('open')

        i++

        if (title == null) {
            return
        }

        title.addEventListener('click', function () {
            if (tb.style.display === 'none') {
                tb.style.display = 'table';
                table.classList.add('open');
            } else {
                tb.style.display = 'none';
                table.classList.remove('open');
            }
        })
    }

    const menus = document.querySelectorAll('.navbar-menu a')

    for (let menu of menus) {
        menu.classList.remove('active');

        if (window.location.pathname === '/' &&
            menu.href === window.location.protocol + '//' + window.location.host + '/'
        ) {
            menu.classList.add('active');
        } else if (window.location.pathname !== '/'
            && menu.href !== window.location.protocol + '//' + window.location.host + '/'
            && window.location.href.startsWith(menu.href)) {
            menu.classList.add('active');
        }
    }

    const privDropdown = document.querySelector('.privacy-policy__dropdown');
    const privMenu = document.querySelector('.privacy-policy__menu');

    if (privDropdown != null && privMenu != null) {
        window.addEventListener('hashchange', () => {
            privMenu.classList.add('hidden');
            privDropdown.classList.remove('open');
        })

        privDropdown.addEventListener('click', function (e) {
            if (privMenu.classList.contains('hidden')) {
                privMenu.classList.remove('hidden');
            } else {
                privMenu.classList.add('hidden');
            }

            if (privDropdown.classList.contains('open')) {
                privDropdown.classList.remove('open');
            } else {
                privDropdown.classList.add('open');
            }
        });
    }

    const separators = document.querySelectorAll('[data-has-separator=true]');

    for (let separator of separators) {
        const seps = separator.querySelectorAll('.separator');

        for (let sep of seps) {
            sep.style.backgroundColor = separator.dataset.separatorColor;
        }
    }

    // window.fleCursor = new Cursor([], 'en');

    closeNavigation()

    const iframe = document.querySelector('.video-button__container iframe')
    const overlay = document.querySelector('.video-button__container .video-button__overlay')

    if (overlay != null) {
        overlay.addEventListener('click', () => {
            const target = iframe.contentDocument.querySelector('.vp-target')

            if (target != null) {
                target.click();
            }
        })
    }
}

const destroy = () => {
    document.body.parentElement.classList.remove('menu-open');
    document.querySelector('.navbar-dropdown__wrapper').classList.remove('open');
    document.activeElement.blur();

    // fleCursor.cancel();
}

window.addEventListener('load', function () {
    window.barbaNavigating = false;

    // new Booking()
    const preloader = new Preloader()

    const bars = document.querySelector('.navbar-dropdown__bars')
    const close = document.querySelector('.navbar-dropdown__social-close')
    const wrapper = document.querySelector('.navbar-dropdown__wrapper')

    const click = () => {
        if (wrapper.classList.contains('open')) {
            wrapper.classList.remove('open')
            document.body.parentElement.classList.remove('menu-open')
        } else {
            wrapper.classList.add('open')
            document.body.parentElement.classList.add('menu-open')
        }
    }

    bars.addEventListener('click', click)
    close.addEventListener('click', click)

    const glry = document.querySelector('.wp-block-migb-masonry-gallery');

    if (glry != null && !glry.hasAttribute('data-barba-prevent')) {
        glry.setAttribute('data-barba-prevent', 'all')
    }

    const imgLoaded = imagesLoaded('.background-image', { background: true }, () => {
        window.slider = new ParallaxSlider()

        const transitionDirection = 'up';

        barba.init({
            timeout: 696969,
            prevent: (el) => {
                if (el.href && el.href.endsWith('.pdf')) {
                    return true
                }

                if (el.href && el.href.endsWith('.jpg')) {
                    return true
                }

                return el.classList && (el.classList.contains('single-gallery-image') || el.classList.contains('prevent'))
            },
            transitions: [{
                name: 'opacity-transition',
                sync: true,
                leave(data) {
                    if (window.innerWidth < 428.98) {
                        return
                    }

                    gsap.set(data.next.container, {
                        position: 'absolute',
                        top: 0,
                        width: '100vw',
                        zIndex: 1,
                    });

                    let direction = {
                        x: '-50%',
                    }

                    if (transitionDirection === 'up') {
                        direction = {
                            y: '-50vh',
                        }
                    }

                    gsap.set(data.next.container.querySelector('.text-reveal span'), {
                        y: '150%',
                        skewY: 7,
                    })

                    return gsap.to(data.current.container, {
                        duration: 1,
                        opacity: .2,
                        ...direction,
                        ease: Expo.easeInOut,
                    })
                },
                enter(data) {
                    if (window.innerWidth < 428.98) {
                        return;
                    }

                    window.barbaNavigating = true;

                    let direction = {
                        x: '100%',
                    }

                    if (transitionDirection === 'up') {
                        direction = {
                            y: '100vh',
                        }
                    }

                    const navbar = document.querySelector('.navbar');
                    navbar.classList.remove('scroll');

                    return gsap.from(data.next.container, {
                        duration: 1,
                        zIndex: 1,
                        ...direction,
                        ease: Expo.easeInOut,
                        onComplete() {
                            gsap.set(data.next.container, {
                                position: 'relative',
                                top: 'unset',
                                width: 'unset',
                                zIndex: 'unset',
                            });

                            gsap.to(".text-reveal span", {
                                duration: 1.5,
                                y: '0%',
                                ease: "power4.out",
                                skewY: 0,
                                stagger: {
                                    amount: 0.3
                                }
                            })


                            setTimeout(() => {
                                window.barbaNavigating = false;
                            }, 600);
                        }
                    })
                }
            }]
        })

        init()

        barba.hooks.after(init)
        barba.hooks.before(destroy)
        barba.hooks.afterEnter(updateHeader)

        const lang = document.querySelector('.navbar-action__language')
        const mobileLangButton = document.querySelector('.button-language__mobile');
        const mobileLangListing = document.querySelector('.language-list__mobile');
        const langMob = document.querySelector('.navbar-dropdown__bars-language')
        const dropdown = document.querySelector('.navbar-action__language-dropdown')
        const dropdownMob = document.querySelector('.navbar-dropdown__bars-language__dropdown')

        if (window.innerWidth < 428.98) {
            if (mobileLangButton) {
                mobileLangButton.addEventListener('click', e => {
                    e.preventDefault();
                    if (mobileLangListing.classList.contains("active")) {
                        mobileLangButton.classList.remove('active')
                        mobileLangListing.classList.remove('active')
                    } else {
                        mobileLangButton.classList.add('active')
                        mobileLangListing.classList.add('active')
                    }
                })
            }

        } else {

            if (dropdown != null) {
                tippy(lang, {
                    content: dropdown.innerHTML,
                    allowHTML: true,
                    interactive: true,
                    placement: 'bottom',
                    animation: 'shift-toward',
                })


                dropdown.remove()
            }
        }

        if (dropdownMob != null) {
            tippy(langMob, {
                content: dropdownMob.innerHTML,
                allowHTML: true,
                interactive: true,
                placement: 'bottom',
                animation: 'shift-toward',
            })
        }

        gsap.from(".text-reveal span", {
            duration: 1.5,
            y: '150%',
            ease: "power4.out",
            delay: .5,
            skewY: 7,
            stagger: {
                amount: 0.3
            }
        })

        let reveals = document.querySelectorAll('.reveal')

        for (let reveal of reveals) {
            reveal.classList.add('reveal__on')
        }

        const scroll = new LocomotiveScroll({
            el: document.querySelector('[data-scroll-container]'),
            smooth: true,
        })

        setTimeout(() => {
            scroll.update()
        }, 500)

        barba.hooks.after(() => {
            window.slider = new ParallaxSlider()

            if (window.innerWidth < 428.98) {
                window.flvScroll.scrollTo('top', {
                    'offset': 0,
                    'callback': function () {
                        // do something...
                    },
                    'duration': 0,
                    'easing': [0.25, 0.00, 0.35, 1.00],
                    'disableLerp': true
                });

                scroll.update()
                triggerResize()
            } else {
                setTimeout(() => {
                    window.flvScroll.scrollTo('top', {
                        'offset': 0,
                        'callback': function () {
                            // do something...
                        },
                        'duration': 0,
                        'easing': [0.25, 0.00, 0.35, 1.00],
                        'disableLerp': true
                    });

                    scroll.update()
                    triggerResize()
                }, 500)
            }
        })

        scroll.on('call', (value, way, obj) => {
            if (value === 'revMask') {
                const reveal_masks = obj.el.querySelectorAll('.text_cover')

                if (reveal_masks && obj.el.classList.contains('is-inview')) {
                    const continueAnim = () => {
                        gsap.to(reveal_masks, {
                            duration: .5,
                            webkitMaskImage: "linear-gradient(170deg, rgb(0, 0, 0) ".concat(100, "%, rgba(255, 255, 255, 0) ").concat(100, "%)"),
                            ease: Linear.easeNone
                        })
                    }

                    gsap.to(reveal_masks, {
                        duration: 1.4,
                        stagger: .1,
                        webkitMaskSize: "cover",
                        webkitMaskImage: "linear-gradient(170deg, rgb(0, 0, 0) ".concat(70, "%, rgba(255, 255, 255, 0) ").concat(100, "%)"),
                        ease: Power0.easeOut,
                        delay: .3,
                        onComplete: continueAnim
                    })
                }
            }
        })

        scroll.on('scroll', (t) => {
            const header = document.querySelector('.navbar')
            const scrollPos = t.scroll.y

            if (scrollPos > 100 && !window.barbaNavigating) {
                header.classList.add('scroll')
            } else {
                header.classList.remove('scroll')
            }

            if (document.querySelector('.privacy-policy__content') != null) {
                const el = document.querySelector('.privacy-policy__menu');

                if (el.getBoundingClientRect().top <= 50) {
                    el.classList.add('stickied');
                } else {
                    el.classList.remove('stickied');
                }
            }
        })

        window.flvScroll = scroll

        const bgCounts = document.querySelectorAll('.background-image').length;
        console.log({ bgCounts })
        if (bgCounts == 0) {
            preloader.progress(100);

            setTimeout(() => {
                preloader.animate();
            }, 1000);
        }
    })

    let loaded = 0;
    let done = false;
    let progress = 0;
    var preloaderStart = new Date();

    imgLoaded.on('progress', (instance) => {
        loaded++
        progress = Math.round((instance.progressedCount / instance.images.length) * 100)
        progress = progress * 2 / 200 * 100

        const preloaderEnd = new Date();
        const duration = preloaderEnd.getTime() - preloaderStart.getTime();

        if (duration >= 1000) {
            preloader.progress(progress)
        }

        console.log({ progress, done })
        if (progress === 100 && !done) {
            preloader.progress(progress)

            done = true

            preloader.animate();
        }
    });

    const hasAccents = document.querySelectorAll('.has-accent')

    for (let hasAccent of hasAccents) {
        hasAccent.parentElement.style.zIndex = 0;
    }


})

window.reserveNow = redirect => {
    window.location.href = redirect
}

window.changeLanguage = (slug, defaultLang) => {
    if (slug === defaultLang)
        window.location.href = '/'
    else
        window.location.href = `/${slug}`
}
